export default "__VITE_ASSET__yW7GSP7g__"